export default __webpack_public_path__ + "static/media/cheque.39bab5e1.svg";